import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsApp.scss';

const WhatsAppIcon = () => (
  <a
    href="https://wa.me/+919799279134"
    target="_blank"
    rel="noopener noreferrer"
    className="ij-whatsapp"
    aria-label="Chat with us on WhatsApp"
  >
    <FaWhatsapp size={26} aria-hidden="true" />
  </a>
);

export default WhatsAppIcon;
